<template>
    <QpeTooltip>
        <template v-slot:hovered_item>
            <v-btn v-if="!is_hide_menu_child"
                icon
                @click="toggle_menu"
            >
                <v-icon color="white">icon-close</v-icon>
            </v-btn>
            <v-btn v-else 
                class="hide-menu-btn__content" 
                icon
                @click="toggle_menu"
            >
                <v-icon>icon-menu</v-icon>
            </v-btn>
        </template>
        <template v-slot:tooltip_content>
            <span>{{ $t('__toggle_menu_btn.hint_text') }}</span>
        </template>
    </QpeTooltip>
</template>

<script>
    export default {
        name: 'toggle_menu_btn',

		components: {
			QpeTooltip: () => import('@/components/tool/qpe_tooltip.vue'),
        },

        props: {
            is_hide_menu: {
                type: Boolean,
                default() {
                    return false
                }
            }
        },

        computed: {
            is_hide_menu_child: {
                get() {
                    return this.is_hide_menu
                },

                set(new_value) {
                    this.$emit('update:is_hide_menu', new_value)
                    this.$emit('trigger_menu_display')
                },
            }
        },

        methods: {
            toggle_menu() {
                this.is_hide_menu_child = !this.is_hide_menu_child
            }   
        }
    }
</script>

<style lang="scss" scoped>
	@import '../../../css/mixin.scss';

    .hide-menu-btn {
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
		height: 56px;
		color: white;
		cursor: pointer;

		&__button {
			color: white !important;
		}

		@include laptop {
			&__content {
                height: 2rem;
                width: 2rem;
				// left: 100%;
				// transform: translate(calc(-100% - 19px), 0);
				color: var(--base_black) !important;
				background:var(--aqua-active);
			}
		}
	}
</style>

<style scoped>
    .main-block-btn >>> .v-icon {
		color: var(--grey-pipe);
	}

	.menu-btn.active >>> .v-icon {
		color: var(--aqua-active);
	}

    .hide-menu-btn__button >>> .v-ripple__container {
		display: none
	}
</style>